import { TemplateItem } from '@anm/api/modules/templates';
import getFromCdn from '@anm/helpers/getFromCdn';

import { templateSelectors } from '../../store/modules/template';

const defaultPreview = `${getFromCdn(
  'images/video-templates/templates_preview.png'
)}`;

const getPageMetaPreview = (currentTemplate?: TemplateItem | null) => {
  if (!currentTemplate?.templateId) return defaultPreview;

  const currentMedia = templateSelectors.selectDefaultTemplateMedia(
    currentTemplate
  );
  const currentPreviewThumb = templateSelectors.selectBigSize(
    currentMedia.thumb
  );

  return currentPreviewThumb.url;
};

export default getPageMetaPreview;